//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
const ObjectFunc = require('@/tbs/util/ObjectFunc')
const MatchEvent = require('@/tbs/model/vo/MatchEvent')
const DataConvertor = require('@/tbs/core/DataConvertor')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_MatchScheduleManagerMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_MatchScheduleManagerMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_MatchScheduleManagerMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    /**
     * @api
     * Handle the custom event condition triggered by 
     * the scene instance.
     * @event The event object contains 
     * {type:String, data:Object, target:VueComponent}
     */
    handleCustomEvent: function(event) {
        console.log('handleCustomEvent', event)
        if (event.type == 'navigate') {
            this._bridge.goToScene(event.data.name, event.data.params, event.data.query)
        }
        else if (event.type == 'load') {
            this.loadEventsByRoundSeq(event.data)
        }
    },
    /*handleRouteBack: function() {
        if (this._bridge.getRouteName() == 'OrgManageMatchSchedule') {
            this._bridge.goToScene('OrgManageMatch', {id: this.target().schedule.id})
        }
        else {
            this._bridge.back()
        }
    },*/
    handleDataLoad: function(parameters) {
        if (this._bridge.isManage()) {
            parameters.matchId = parameters.id
        }
        return parameters
    },
    handleDataLoaded: function() {
        this.target().schedule.id = this._bridge.getRouteParam('id')
        this.target().schedule.matchId = this._bridge.getRouteQuery('matchId')
        const roundSeq = this._bridge.getRouteQuery('roundSeq')
        this.target().onRoundTabClick(Number(roundSeq) - 1)
    },
    loadEventsByRoundSeq: function(data) {
        console.log('loadEventsByRoundSeq', data)
        const self = this
        // update the router url with the given round seq
        self._bridge.replaceQuery({roundSeq: data.roundSeq})

        const convertor = new MatchEvent
        const wrapper = DataConvertor.wrapper(convertor)
        const source = convertor.view.query
        const service = 'query' + ObjectFunc.capitalizeFirstLetter(wrapper)
        const parameters = { 
            matchId: data.matchGroupId, 
            round: data.round,
            stageId: data.stageId
        }
        self._bridge.addResourceListener(service, function(e) {
            self._bridge.removeResourceListener(service, e.handler)
            console.log('query.data', service, e.data)
            if (e.data.result == true) {
                const entityData = e.data.payload
                const eventList = DataConvertor.transform(convertor, entityData, 'query')
                eventList.sort(function(a, b) {
                    return new Date(a.startDateTime).getTime() - new Date(b.startDateTime).getTime()
                })
                for (let i = 0; i < eventList.length; i++) {
                    let event = eventList[i]
                    let prevEvent = i > 0 ? eventList[i - 1] : null
                    if (prevEvent) {
                        event.prevStartDateTime = prevEvent.startDateTime
                    }
                }
                console.log('@eventList', eventList)
                const wrapper = DataConvertor.wrapper(convertor, true)
                self.target()[wrapper] = eventList
            }
        })
        self._bridge.callResourceInstance(service, {
            baseUrl: source.baseUrl,
            apiPrefix: source.apiPrefix,
            apiSuffix: source.apiSuffix,
            serviceName: source.service,
            method: 'GET',
            parameters: parameters
        })
    },
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_MatchScheduleManagerMediator, BaseMediator);

module.exports = tbs_controller_MatchScheduleManagerMediator